/*
 * @Author: Duanjiaojiao
 * @Date: 2023-02-27 15:42:54
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2023-03-03 18:07:43
 * @Description:
 * @FilePath: /BM-Main/src/components/Map/t-map.js
 * @props:
 */
import fetch from '@zz/fetch'
import config from './config'
import { url } from '@zz-common/zz-utils';
import { LBSMonitor } from '@/utils/ErrorMonitor';

const query = {
  output: 'jsonp',
  key: config.apiKey
}

// 逆地址解析（坐标位置描述）location=   地址解析（地址转坐标）address=
const geocoderApi = (params) => {
  const reqUrl = url.setParams(
    {
      ...query,
      ...params
    },
    config.API.address
  )
  return fetch({ method: 'jsonp', url: reqUrl }).then(res => {
    if (res.status !== 0) {
      LBSMonitor({
        key: config.apiKey, apiName: '逆地址解析（坐标位置描述）', api: config.API.address, msg: res.message
      })
    }
    return res
  })
}

// 获取省市区列表
const districtApi = (params) => {
  const reqUrl = url.setParams(
    {
      ...query,
      ...params
    },
    config.API.district
  )
  return fetch({ method: 'jsonp', url: reqUrl }).then(res => {
    if (res.status !== 0) {
      LBSMonitor({
        key: config.apiKey, apiName: '行政区划列表', api: config.API.district, msg: res.message
      })
    }
    return res
  })
}

// 关键字搜索
const suggestionApi = (params) => {
  const reqUrl = url.setParams(
    {
      ...query,
      ...params
    },
    config.API.suggestion
  )
  return fetch({ method: 'jsonp', url: reqUrl }).then(res => {
    if (res.status !== 0) {
      LBSMonitor({
        key: config.apiKey, apiName: '关键词输入提示', api: config.API.suggestion, msg: res.message
      })
    }
    return res
  })
}

// 周边推荐
const exploreApi = (params) => {
  const reqUrl = url.setParams(
    {
      ...query,
      ...params
    },
    config.API.explore
  )
  return fetch({ method: 'jsonp', url: reqUrl }).then(res => {
    console.log('res: ', res);
    if (res.status !== 0) {
      LBSMonitor({
        key: config.apiKey, apiName: '周边推荐（explore）', api: config.API.explore, msg: res.message
      })
    }
    return res
  })
}

export {
  geocoderApi,
  districtApi,
  suggestionApi,
  exploreApi
}
